<script setup lang="ts">
defineProps<{
  name: string
  id: string
}>()

const payload = computed(() => {
  return {
    filters: [],
    sort: ""
  }
})
</script>

<template>
  <GAList
    :id="id ?? ''"
    :name="name ?? ''"
    entity="pageList"
    :payload="payload"
  >
    <slot />
  </GAList>
</template>
